import { Cart } from './cart.types'
import { emitterProps, globalEmitter } from './emitter-event'

export class NativeFetcher {
  async get(endpoint: string): Promise<Cart | undefined> {
    const init = {
      method: 'GET'
    }

    const response = await fetch(endpoint, init)
    if (response.ok) return await response.json()
    else {
      this.error(response)
      return undefined
    }
  }

  async post(endpoint: string, body: any) {
    const init = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: typeof body === 'string' ? body : JSON.stringify(body)
    }

    const response = await fetch(endpoint, init)
    if (response.ok) return await response.json()
    else return await this.error(response)
  }

  async error(response: Response, options = { silent: false }) {
    const { silent } = options
    const error = await response.json()

    if (silent) {
      console.error('Cart Error:', error.description)
    } else {
      globalEmitter.emit(emitterProps.notice.global, {
        type: 'error',
        content: error.description || error.message
      })
      return { error: error.description || error.message }
    }
  }
}
